module.exports = __webpack_public_path__ + "../resources/images/SkyCode_44-e16889da0b81a97a363ad8d508514fa7.svg";